// Runtime singleton para parámetros del SystemConfig que aplican al frontend
// (REQ-ADMIN-003-004 — el cambio en /admin/configuracion debe propagarse).
//
// Se hidrata desde /system-config al iniciar sesión y al editar el formulario.
// Las utilidades como formatCurrency leen de aquí para reflejar el cambio
// sin que cada caller tenga que pasar el valor explícitamente.

export interface RuntimeConfig {
  currency: string;
  language: string;
  timezone: string;
}

const DEFAULTS: RuntimeConfig = {
  currency: 'COP',
  language: 'es',
  timezone: 'America/Bogota',
};

export const runtimeConfig: RuntimeConfig = { ...DEFAULTS };

export function setRuntimeConfig(partial: Partial<RuntimeConfig>) {
  if (partial.currency) runtimeConfig.currency = partial.currency;
  if (partial.language) runtimeConfig.language = partial.language;
  if (partial.timezone) runtimeConfig.timezone = partial.timezone;
}
